import React from "react";

const ExcelFile = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4V30H28V10L20 2Z"
        fill="#37B450"
      />
      <path d="M20 2L28 10H20V2Z" fill="#0C9227" />
      <path
        d="M21.4027 19.64C21.8827 19.64 22.3041 19.7227 22.6667 19.888C23.0294 20.0533 23.3387 20.2987 23.5947 20.624L22.9787 21.336C22.7601 21.0587 22.5201 20.856 22.2587 20.728C22.0027 20.5947 21.7041 20.528 21.3627 20.528C21.1387 20.528 20.9521 20.5573 20.8027 20.616C20.6587 20.6747 20.5521 20.752 20.4827 20.848C20.4187 20.944 20.3867 21.0507 20.3867 21.168C20.3867 21.312 20.4427 21.4347 20.5547 21.536C20.6667 21.632 20.8587 21.712 21.1307 21.776L22.1147 22C22.6374 22.1173 23.0107 22.2933 23.2347 22.528C23.4641 22.7573 23.5787 23.056 23.5787 23.424C23.5787 23.7707 23.4881 24.0693 23.3067 24.32C23.1254 24.5653 22.8721 24.7547 22.5467 24.888C22.2214 25.016 21.8481 25.08 21.4267 25.08C21.0587 25.08 20.7201 25.0373 20.4107 24.952C20.1067 24.8613 19.8347 24.7387 19.5947 24.584C19.3547 24.4293 19.1547 24.2507 18.9947 24.048L19.6187 23.304C19.7414 23.4747 19.8934 23.6267 20.0747 23.76C20.2561 23.8933 20.4614 24 20.6907 24.08C20.9254 24.1547 21.1707 24.192 21.4267 24.192C21.6454 24.192 21.8294 24.168 21.9787 24.12C22.1334 24.0667 22.2481 23.9947 22.3227 23.904C22.4027 23.808 22.4427 23.6933 22.4427 23.56C22.4427 23.4213 22.3947 23.304 22.2987 23.208C22.2081 23.1067 22.0374 23.0293 21.7867 22.976L20.7147 22.736C20.4054 22.6613 20.1387 22.5653 19.9147 22.448C19.6961 22.3253 19.5281 22.1707 19.4107 21.984C19.2987 21.792 19.2427 21.5653 19.2427 21.304C19.2427 20.9893 19.3281 20.7067 19.4987 20.456C19.6694 20.2053 19.9147 20.008 20.2347 19.864C20.5601 19.7147 20.9494 19.64 21.4027 19.64Z"
        fill="white"
      />
      <path
        d="M15.374 24.112H18.158V25H14.27V19.72H15.374V24.112Z"
        fill="white"
      />
      <path
        d="M13.0568 25H11.7448L10.5928 23.128L9.45684 25H8.19284L10.0088 22.336L8.32084 19.72H9.61684L10.6808 21.496L11.7608 19.72H12.9608L11.2648 22.296L13.0568 25Z"
        fill="white"
      />
    </svg>
  );
};

export default ExcelFile;
